export const OPTIMIZELY_VISITOR_ID_STORAGE_KEY = 'optimizely.visitor_id'
